import dot from 'dot-object'

import type { IUser } from '~/entities/user/user/interfaces/user'

import type { SwymAuthor } from '~/features-shared/content/interfaces/swym-content'

const MOVE_PROPS = [
  ['ds6w:resourceUid', 'uid'],
  ['firstName', 'first_name'],
  ['lastName', 'last_name'],
  ['ut_state', 'user_state'],
]

export function _userParser(user: SwymAuthor = {}): IUser {
  const _user = user as unknown as IUser

  MOVE_PROPS.forEach(([from, to]) => {
    dot.move(from, to, user)
  })

  if (!_user.displayName) {
    _user.displayName = (user.first_name && user.last_name)
      ? `${user.first_name} ${user.last_name}`
      : (user.fullName || user.login || user.username || '')
  }

  return _user
}
